var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8599 2.32031H11.0693C13.5735 2.32031 14.8256 2.32031 15.6951 2.93294C15.9442 3.10846 16.1654 3.31663 16.3519 3.5511C17.0028 4.36947 17.0028 5.54789 17.0028 7.90473V9.85927C17.0028 12.1346 17.0028 13.2722 16.6427 14.1808C16.0638 15.6415 14.8396 16.7937 13.2876 17.3386C12.3222 17.6775 11.1135 17.6775 8.69597 17.6775C7.31454 17.6775 6.62383 17.6775 6.07217 17.4838C5.18531 17.1725 4.48576 16.5141 4.15498 15.6794C3.94922 15.1602 3.94922 14.5101 3.94922 13.2099V9.99888",
    stroke: "#3276E8",
    strokeWidth: 1.22857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0008 10C17.0008 11.4136 15.8549 12.5595 14.4413 12.5595C13.9301 12.5595 13.3274 12.4699 12.8303 12.6031C12.3887 12.7215 12.0437 13.0664 11.9254 13.5081C11.7922 14.0051 11.8818 14.6078 11.8818 15.119C11.8818 16.5326 10.7359 17.6786 9.32227 17.6786",
    stroke: "#3276E8",
    strokeWidth: 1.22857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3245 5.39174L3.18164 5.39174M6.25307 2.32031V8.46317",
    stroke: "#3276E8",
    strokeWidth: 1.22857,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAdd);
export default __webpack_public_path__ + "static/media/file-add.278ec79823eb01df7d7328f0159cb31f.svg";
export { ForwardRef as ReactComponent };